module.exports = __webpack_public_path__ + "1_0_64/img/arrow_check.2e89ae36.svg";